/** Self-serve item issue codes used on the delivery-help wizard. */
export const ItemIssueSelfServe = {
  Damaged: 1001,
  Missing: 1003,
  Spoiled: 1004,
  Other: 1099,
} as const;

export type ItemIssueSelfServeCode =
  (typeof ItemIssueSelfServe)[keyof typeof ItemIssueSelfServe];

export interface AutoIssueCreditRequest {
  credit_choice: boolean;
  item_issue?: ItemIssueSelfServeCode | null;
  skus?: number[];
  free_text?: string | null;
  should_issue_credit?: boolean;
  auto_credit_amount?: number | null;
}

export type AutoIssueCreditResponse = AutoIssueCreditRequest;
